import {
  Alert,
  Button,
  Chip,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import {
  useConsistencyWarnings,
  useDismissWarning,
} from '../../api/queries/consistency';

interface Props {
  entityId: string;
}

export function ConsistencyWarningsPanel({ entityId }: Props) {
  const warnings = useConsistencyWarnings({ entityId });
  const dismiss = useDismissWarning();

  if (warnings.isLoading) return <CircularProgress size={18} />;
  const open = warnings.data?.filter((w) => w.status === 'open') ?? [];
  const other = warnings.data?.filter((w) => w.status !== 'open') ?? [];

  return (
    <Stack spacing={2}>
      {open.length === 0 && (
        <Alert severity="success">
          No open consistency warnings for this entity.
        </Alert>
      )}
      <List>
        {open.map((w) => (
          <ListItem
            key={w.id}
            divider
            secondaryAction={
              <Button size="small" onClick={() => dismiss.mutate(w.id)}>
                Dismiss
              </Button>
            }
          >
            <ListItemText
              primary={
                <Stack direction="row" spacing={1} alignItems="center">
                  <Chip size="small" color="warning" label={w.warningType} />
                  {w.score !== null && w.score !== undefined && (
                    <Typography variant="caption" color="text.secondary">
                      score {Math.round(w.score * 100)}%
                    </Typography>
                  )}
                </Stack>
              }
              secondary={new Date(w.createdAt).toLocaleString()}
            />
          </ListItem>
        ))}
      </List>
      {other.length > 0 && (
        <>
          <Typography variant="caption" color="text.secondary">
            {other.length} resolved / dismissed
          </Typography>
        </>
      )}
    </Stack>
  );
}
